import React from 'react';

export class Label extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const p = this.props;
        return (
            <label className={ `marketkit-checkbox-wrapper-label-sub` }>
                { p.children }
            </label>
        )
    }
}

export default Label;